var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.device)?_c('v-flex',{staticClass:"title-block"},[_c('div',{staticClass:"img-container"},[_c('div',{domProps:{"innerHTML":_vm._s(require(`!html-loader!@/assets/device-icons/${_vm.deviceTypes[_vm.device.device_type].img}.svg`))}})]),_c('div',{staticClass:"title-block__name"},[_vm._v("\n        "+_vm._s(_vm.device.name)+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }